const PLAY_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4.16667 2.5L17.5 10L4.16667 17.5V2.5Z" fill="currentColor"/></svg>`;

class VideoMessagesPlayButtons {
	constructor(container) {
		container.querySelectorAll('.wp-block-video').forEach((figure) => {
			const video = figure.querySelector('video');
			if (!video || figure.dataset.playEnhanced === 'true') return;

			video.removeAttribute('controls');
			video.setAttribute('playsinline', '');
			video.setAttribute('preload', 'metadata');

			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'video-messages__play';
			button.setAttribute('aria-label', 'Play video');
			button.innerHTML = PLAY_ICON_SVG;

			figure.classList.add('video-messages__figure');
			figure.appendChild(button);

			button.addEventListener('click', () => {
				video.setAttribute('controls', '');
				figure.classList.add('is-playing');
				video.play();
			});

			video.addEventListener('pause', () => figure.classList.remove('is-playing'));
			video.addEventListener('play',  () => figure.classList.add('is-playing'));
			video.addEventListener('ended', () => {
				figure.classList.remove('is-playing');
				video.removeAttribute('controls');
			});

			figure.dataset.playEnhanced = 'true';
		});
	}

	static init() {
		document
			.querySelectorAll('.video-messages, .video-messages-slider')
			.forEach((el) => new VideoMessagesPlayButtons(el));
	}
}

export default VideoMessagesPlayButtons;
